import { createTheme } from "@mui/material/styles";
import { faIR } from "@mui/material/locale";
import "../Theme.types";
export const betaDarkTheme = createTheme({
    direction: "rtl",
    palette: {
        mode: "dark",
        primary: {
            main: "#FCE6B7",
            light: "#FFF3D6",
            dark: "#513229",
            contrastText: "#291914",
        },
        secondary: {
            main: "#D7D4B1",
            light: "#E7E4CC",
            dark: "#6A6639",
            contrastText: "#22201C",
        },
        error: {
            main: "#ECB0B0", // از 90 لایت
            light: "#F9E6E6", // از 95 لایت
            dark: "#C10101", // از 50 لایت
            contrastText: "#6A0101",
        },
        success: {
            main: "#B5E28A", // G-90
            light: "#EFF9E6", // G-95
            dark: "#5EC101", // G-50
            contrastText: "#275100",
        },
        warning: {
            main: "#E2CC8A", // Y-90
            light: "#F9F4E6", // Y-95
            dark: "#C19101", // Y-50
            contrastText: "#513000",
        },
        info: {
            main: "#8AD2E2", // B-90
            light: "#E8F5F9", // B-95
            dark: "#019EC1", // B-50
            contrastText: "#004251",
        },
        background: {
            default: "#1C130C",
            paper: "#241B12",
        },
        text: {
            primary: "#F6F3EA",
            secondary: "#C2BDAD",
        },
    },
    customColors: {
        primary: {
            98: "#170F0C",
            95: "#291914",
            90: "#3C241D",
            80: "#513229",
            60: "#805042",
            50: "#A76A58",
            40: "#C9A69C",
            30: "#E2D0CB",
            20: "#EFE8E6",
            10: "#F8F5F4",
            primaryContainer: "#3C241D",
            onPrimaryContainer: "#EFE8E6",
            onPrimary: "#170F0C",
        },
        neutral: {
            98: "#22201C",
            95: "#3D3A34",
            90: "#5A5649",
            80: "#746F63",
            70: "#989281",
            50: "#C2BDAD",
            40: "#EDE9DE",
            30: "#F6F3EA",
            20: "#FBFAF6",
            10: "#FFFFFF",
            surfaceContainerLowest: "#120D08",
            surfaceContainerLow: "#1C130C",
            surfaceContainer: "#241B12",
            onSurface: "#F6F3EA",
            onSurfaceVariant: "#DAD6C8",
            outline: "#5A5649",
        },
        error: {
            98: "#6A0101",
            95: "#C10101",
            90: "#ECB0B0",
            50: "#F9E6E6",
            20: "#FDF8F8",
            errorContainer: "#6A0101",
            onErrorContainer: "#F9E6E6",
            onError: "#FDF8F8",
        },
        success: {
            98: "#275100", // معکوس
            95: "#5EC101",
            90: "#B5E28A",
            50: "#EFF9E6",
            20: "#F4F7F1",
            successContainer: "#275100",
            onSuccessContainer: "#EFF9E6",
            onSuccess: "#F4F7F1",
        },
        warning: {
            98: "#513000", // معکوس
            95: "#C19101",
            90: "#E2CC8A",
            50: "#F9F4E6",
            20: "#F9F6F4",
            warningContainer: "#513000",
            onWarningContainer: "#F9F4E6",
            onWarning: "#F9F6F4",
        },
        info: {
            98: "#004251", // معکوس
            95: "#019EC1",
            90: "#8AD2E2",
            50: "#E8F5F9",
            20: "#F2F7F8",
            infoContainer: "#004251",
            onInfoContainer: "#E8F5F9",
            onInfo: "#F2F7F8",
        },
    },
    typography: {
        fontFamily: ["IRANSansX", "IRANSansXBold"].join(","),
        displayLarge: {
            fontSize: "48px",
            lineHeight: "72px",
            fontWeight: 700,
            color: "#F6F3EA",
        },
        displaySmall: {
            fontSize: "32px",
            lineHeight: "56px",
            fontWeight: 700,
            color: "#F6F3EA",
        },
        headlineLarge: {
            fontSize: "24px",
            lineHeight: "44px",
            fontWeight: 700,
            color: "#F6F3EA",
        },
        titleLarge: {
            fontSize: "16px",
            lineHeight: "28px",
            fontWeight: 700,
            color: "#F6F3EA",
        },
        titleMedium: {
            fontSize: "14px",
            lineHeight: "24px",
            fontWeight: 700,
            color: "#F6F3EA",
        },
        labelLarge: {
            fontSize: "16px",
            lineHeight: "20px",
            fontWeight: 500,
            color: "#F6F3EA",
        },
        labelMedium: {
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: 500,
            color: "#F6F3EA",
        },
        labelSmall: {
            fontSize: "12px",
            lineHeight: "16px",
            fontWeight: 500,
            color: "#F6F3EA",
        },
        bodyLarge: {
            fontSize: "16px",
            lineHeight: "28px",
            fontWeight: 500,
            color: "#F6F3EA",
        },
        bodyMedium: {
            fontSize: "14px",
            lineHeight: "24px",
            fontWeight: 500,
            color: "#F6F3EA",
        },
        bodySmall: {
            fontSize: "12px",
            lineHeight: "24px",
            fontWeight: 500,
            color: "#F6F3EA",
        },
    },
}, faIR);
